import isString from 'lodash/isString';

export const validObjectId = (objectID) => {
  if (isString(objectID) && objectID.length !== 0) return true;
  if (typeof objectID === 'number' && objectID !== 0) return true;
  return false;
};

// export const objectFacets = ['products.title', 'bodyParts.title', 'painPoints.title', 'resourceTopics.title']
/**
 * filter-show-state from uri
 * @param  {string} query
 * @returns {boolean}
 */
export const isFiltersQuery = (query) => Object.keys(query).some((paramKey) => ~paramKey.indexOf('filter'));

/**
 * Build facet-prerefinement-object for page-entry
 * @param  {object} prerefinements - object with shape of {products: {title: "blackroll"}}
 * @param {String} pageProfile
 * @returns {object} keys fascet title - values prerefined facet values
 */
export const prerefinementsByPageProfile = (prerefinements, pageProfile) => {
  if (!prerefinements || !pageProfile) return {};

  return exercisesFacets(pageProfile).reduce((acc, curr) => {
    const [obj, attr] = curr.split('.');
    if (obj && attr) {
      const filterValues = prerefinements[obj]?.map((o) => o[attr]) || [];
      if (filterValues.length) acc[curr] = filterValues;
    }
    return acc;
  }, {});
};

/**
 * Maps Page-entry-facetProfile to list of facets
 * @param  {string} pageProfile - fixed values from api
 * @returns {array} list of facet-titles, defaults to []
 */
export const exercisesFacets = (pageProfile) => {
  const facetProfiles = {
    none: [],
    exerciseByProduct: ['products.title', 'bodyParts.title', 'difficulty', 'trainingGoals'],
    exerciseByBodyPart: ['bodyParts.title', 'products.title', 'difficulty', 'trainingGoals'],
    routineByPainPoint: ['painPoints.title'],
    routineBySport: ['sports.title', 'trainingGoals.title'],
    routineByTopic: ['routineTopics.title'],
  };
  return facetProfiles[pageProfile] || facetProfiles.none;
};

export const setupFilterPresets = (entry) => {
  const presetKeys = {
    products: 'products.title',
    bodyParts: 'bodyParts.title',
    painPoints: 'painPoints',
    sports: 'sports',
    routineTopics: 'routineTopics',
    difficulty: 'difficulty',
    trainingGoals: 'trainingGoals',
  };

  return Object.keys(presetKeys).reduce((acc, curr) => {
    const key = presetKeys[curr];
    if (entry[curr]) acc[key] = entry[curr];
    return acc;
  }, {});
};

/**
 * map pageProfile to search reslut type
 * @param  {string} pageProfile
 * @returns {string} exercise|routine
 */
export const resultType = (pageProfile) => {
  const types = {
    none: 'exercise',
    exerciseByProduct: 'exercise',
    exerciseByBodyPart: 'exercise',
    routineByPainPoint: 'routine',
    routineBySport: 'routine',
    routineByTopic: 'routine',
  };
  return types[pageProfile] || types.none;
};

export const enrichBlocksWithExerciseData = async (blocks) => {
  if (!blocks) {
    return Promise.resolve(blocks);
  }
  const nuxtApp = tryUseNuxtApp();

  if (!nuxtApp) {
    return Promise.resolve(blocks);
  }

  const { $algoliaWorkouts } = nuxtApp;

  // get all object ids from the blocks
  const exerciseObjectIds = blocks.filter((block) => block.exerciseObjectId).map((block) => block.exerciseObjectId);

  if (exerciseObjectIds.length > 0) {
    // fetch exercises from algolia
    const response = await $algoliaWorkouts.fetchExercises(exerciseObjectIds);

    if (response && response.results) {
      // enrich blocks with exercise data
      blocks.forEach((block) => {
        const exercise = response.results
          .filter((e) => e)
          .find((exercise) => exercise.objectID === block.exerciseObjectId);

        if (exercise) {
          block.exerciseData = exercise;
        }
      });
    }
  }

  return blocks;
};
